<template>
    <div>
        <loader v-if="isLoading" />
        <template v-else-if="isDisabled">
            <div class="input disabled">
                {{ selectedValue ? selectedValue.countryTranslation : '' }}
            </div>
        </template>
        <template v-else>
            <div class="control is-expanded">
                <span class="select is-fullwidth">
                    <select :value="value" @input="onChange" :disabled="isDisabled">
                        <option v-if="value == null" :value="null" disabled hidden>
                            {{ $t('choose') }}
                        </option>
                        <option v-for="(option, key) in options" :value="option.alpha2Code" :key="key">
                            {{ option.countryTranslation }}
                        </option>
                    </select>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'nationalitiesSelect',
    props: {
        isDisabled: {
            type: Boolean,
        },
        value: {
            type: [String, Object],
        },
    },
    data() {
        return {
            options: [],
            isLoading: true,
        };
    },
    created() {
        this.getCountriesList();
    },
    computed: {
        selectedValue() {
            return this.options.find((x) => {
                return x.alpha2Code == this.value;
            });
        },
    },
    methods: {
        getCountriesList: function () {
            this.isLoading = true;
            //change value field to 2 or 3; @kurt needs.
            this.options = require('./../services/countries.json');

            this.options.forEach((x) => {
                x.countryTranslation = this.$t(`nationality.${x.alpha2Code}`);
            });

            this.options.sort((a, b) => {
                return a.countryTranslation.localeCompare(b.countryTranslation);
            });

            this.isLoading = false;
        },
        onChange(event) {
            var value = event.target.value;
            this.$emit('input', value);
        },
    },
    i18n: {
        messages: {
            en: {
                choose: 'Choose',
                ...require('./../i18n/nationalities.en.json'),
            },
            fr: {
                choose: 'Choisir',
                ...require('./../i18n/nationalities.fr.json'),
            },
            nl: {
                choose: 'Kies',
                ...require('./../i18n/nationalities.nl.json'),
            },
        },
    },
};
</script>
